/* eslint-disable no-undef */

// eslint-disable-next-line no-unused-vars
import { Location, Zone } from '@/generated-clients/myTrips'

const EARTH_RADIUS = 6371000

export function findClosestZoneContainingLocation (zones: Zone[], location: Location): Zone | null {
  if (zones.length === 0) {
    return null
  }

  const sortedZones = [...zones]
  sortedZones.sort((a, b) => distanceToCenter(a, location) - distanceToCenter(b, location))

  const closestZone = sortedZones[0]

  return distanceToCenter(closestZone, location) <= closestZone.radius ? closestZone : null
}

function distanceToCenter (zone: Zone, location: Location): number {
  const center = { latitude: zone.latitude, longitude: zone.longitude }

  const latDistance = toRadians(center.latitude - location.latitude)
  const lonDistance = toRadians(center.longitude - location.longitude)

  const a =
    Math.pow(Math.sin(latDistance / 2), 2) +
    Math.cos(toRadians(location.latitude)) * Math.cos(toRadians(center.latitude)) * Math.pow(Math.sin(lonDistance / 2), 2)

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))

  return EARTH_RADIUS * c
}

function toRadians (degrees: number): number {
  return degrees * (Math.PI / 180.0)
}
